import { useIsAuthenticated } from "@azure/msal-react";
import { Navigate, useLocation } from "react-router-dom";
import { LoginForm } from "@/components/login-form";
import loginBg from "@/assets/login-bg.jpg";
import { loginReturnTo } from "@/lib/login-return";

export default function LoginPage() {
  const isAuthenticated = useIsAuthenticated();
  const location = useLocation();
  const from = loginReturnTo(location.state);

  if (isAuthenticated) {
    return <Navigate to={from} replace />;
  }

  return (
    <div className="grid min-h-svh lg:grid-cols-2">
      <div className="flex flex-col gap-4 p-6 md:p-10">
        <div className="flex flex-1 items-center justify-center">
          <div className="w-full max-w-xs">
            <LoginForm />
          </div>
        </div>
      </div>
      <div className="bg-muted relative hidden lg:block">
        <img
          src={loginBg}
          alt="Power line tower at dusk"
          className="absolute inset-0 h-full w-full object-cover dark:brightness-[0.2] dark:grayscale"
        />
      </div>
    </div>
  );
}
